import { Loader } from "@joonapp/web-shared"

import TodoEmptyState from "./TodoEmptyState"
import TodoUserListItem from "./TodoUserListItem"
import { useCoachingGroupsQuery } from "../../networking/coachingGroups/queries"
import { useClientsWithTodos } from "../../pages/home/hooks/useClientsWithTodos"

const TodoUserList = () => {
  const { isLoading } = useCoachingGroupsQuery()
  const clientsWithTodos = useClientsWithTodos()

  return (
    <div className="flex-col bg-bgXLightGray w-full p-4 flex gap-2 min-h-full">
      {isLoading ? (
        <div className="flex items-center justify-center h-[400px]">
          <Loader />
        </div>
      ) : clientsWithTodos.length > 0 ? (
        clientsWithTodos.map(({ coachingGroup }) => (
          <TodoUserListItem
            key={coachingGroup.id}
            coachingGroup={coachingGroup}
          />
        ))
      ) : (
        <TodoEmptyState />
      )}
    </div>
  )
}

export default TodoUserList
